/*
  Ready-made designs, each a `design` object in exactly the shape the app
  stores on a user (see profileStyle.js). Shown on the landing page
  (landing/src/content/copy.js re-exports this) and offered as one-click
  starting points in the dashboard, so both always list the same six.
*/
export const TEMPLATES = [
  {
    id: 'gece',
    design: {
      backgroundType: 'solid', backgroundColor: '#0E0D14',
      buttonStyle: 'filled', buttonShape: 'pill',
      buttonColor: '#7355F0', buttonTextColor: '#FFFFFF',
      textColor: '#F2EDE3', font: 'inter'
    }
  },
  {
    id: 'studyo',
    design: {
      backgroundType: 'gradient', gradientFrom: '#EAAFC8', gradientTo: '#654EA3',
      buttonStyle: 'filled', buttonShape: 'rounded',
      buttonColor: '#FFFFFF', buttonTextColor: '#654EA3',
      textColor: '#FFFFFF', font: 'poppins'
    }
  },
  {
    id: 'kagit',
    design: {
      backgroundType: 'solid', backgroundColor: '#F2EDE3',
      buttonStyle: 'filled', buttonShape: 'square',
      buttonColor: '#0E0D14', buttonTextColor: '#F2EDE3',
      textColor: '#0E0D14', font: 'playfair'
    }
  },
  {
    id: 'neon',
    design: {
      backgroundType: 'solid', backgroundColor: '#0B1020',
      buttonStyle: 'filled', buttonShape: 'pill',
      buttonColor: '#3BF0C0', buttonTextColor: '#0B1020',
      textColor: '#3BF0C0', font: 'roboto-mono'
    }
  },
  {
    id: 'vitrin',
    design: {
      backgroundType: 'solid', backgroundColor: '#6160AB',
      buttonStyle: 'filled', buttonShape: 'square',
      buttonColor: '#1F1C1C', buttonTextColor: '#6160AB',
      textColor: '#1F1C1C', font: 'default'
    }
  },
  {
    id: 'sahne',
    design: {
      backgroundType: 'solid', backgroundColor: '#1C1927',
      buttonStyle: 'outline', buttonShape: 'rounded',
      buttonColor: '#F2EDE3', buttonTextColor: '#1C1927',
      textColor: '#F2EDE3', font: 'inter'
    }
  }
];
